import * as React from "react";
import { Link } from "react-router-dom";
import C from "classnames";
export const AlertLink = (props) => {
    return props.to ? (React.createElement(Link, { className: C("alert-link"), to: props.to, "data-testid": props.testId }, props.children)) : (React.createElement("a", { className: C("alert-link"), href: props.href, "data-testid": props.testId }, props.children));
};
//# sourceMappingURL=AlertLink.js.map